<template>
    <div class="scroll-box-horizontally">
        <div class="row">
            <div class="col-12">
                <div class="py-1">
                    <!-- result counter section -->
                    <i class="fas fa-poll-h fa-sm"></i>  
                    <span class="font-weight-bold"> Found</span> 
                    {{resultsCountMsg}} 

                    <!-- clear filters -->
                    <span v-if="clearFilterCheck" class="ml-3">
                        <div class="input-group input-group-sm search-filter-fields">
                            <button @click.prevent="emitClearFilterFxn" class="form-control btn btn-light bg-white btn-sm text-danger search-filter-buttons">
                                Clear filters <i class="fas fa-times-circle fa-sm"></i>
                            </button>
                        </div>
                    </span>
                    
                    <!-- sorting section -->
                    <span class="ml-3">
                        <div class="input-group input-group-sm search-filter-fields">
                            <select v-model="sortBy" @change="emitSortByFxn" ref="country" class="custom-select no-lines bg-white search-filter-selects" style="border-color: #DFDFDF;">
                                <option selected disabled value="">sort by</option>
                                <option v-for="(sortOption, index) in theSortOptions" :key="index" :value="sortOption.value">{{sortOption.text}}</option>
                            </select>
                        </div>
                    </span>

                    <!-- set price section -->
                    <span class="ml-3">
                        <span class="font-weight-bold">Price </span>  
                        <input v-model="priceMin" @keyup.enter="emitSetPriceFxn" type="text" placeholder="min" class="form-control form-control-sm no-lines bg-white search-filter-fields search-filter-inputs">
                        <input v-model="priceMax" @keyup.enter="emitSetPriceFxn" type="text" placeholder="max" class="form-control form-control-sm no-lines bg-white search-filter-fields search-filter-inputs">
                    </span>

                    <!-- select condition section -->
                    <span class="ml-3"> 
                        <span class="font-weight-bold">Condition </span> 
                        <div class="input-group input-group-sm search-filter-fields">
                            <select v-model="selectedCondition" @change="emitConditionFxn" ref="condition" class="custom-select no-lines bg-white search-filter-selects" style="border-color: #DFDFDF;">
                                <option selected disabled value="">select condition</option>
                                <option v-for="(condition, index) in theConditions" :key="index" :value="condition.condition">{{condition.condition}}</option>
                            </select>
                        </div>
                    </span>

                    <!-- select category section -->
                    <span class="ml-3">  
                        <span class="font-weight-bold">Category </span>
                        <div class="input-group input-group-sm search-filter-fields">
                            <select v-model="selectedCategory" @change="emitCategoryFxn()" ref="category" class="custom-select no-lines bg-white search-filter-selects" style="border-color: #DFDFDF;">
                                <option selected disabled value="">select category</option>
                                <option v-for="(category, index) in theCategories" :key="index" :value="category.category">{{category.category}}</option>
                            </select>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchFilterMobile",
    props: {
        resultsCountMsg: {
            type: String,
            required: false
        },
        theSortOptions: {
            type: Array,
            required: false
        },
        theConditions: {
            type: Array,
            required: false
        },
        theCategories: {
            type: Array,
            required: false
        },
        clearFilterCheck: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            sortBy: '',
            priceMin: null,
            priceMax: null,
            selectedCategory: '',
            selectedCondition: '',
        }
    },
    methods: {
        emitSortByFxn() {
            this.$emit('emitSortByFxn', this.sortBy)
        },
        emitSetPriceFxn() {
            let priceObj = {
                min: this.priceMin,
                max: this.priceMax
            }
            this.$emit('emitSetPriceFxn', priceObj)
        },
        emitConditionFxn() {
            let conditionObj = {
                condition: this.selectedCondition
            }
            this.$emit('emitConditionFxn', conditionObj)
        },
        emitCategoryFxn() {
            let categoryObj = {
                category: this.selectedCategory
            }
            this.$emit('emitCategoryFxn', categoryObj)
        },
        emitClearFilterFxn() {
            this.$emit('emitClearFilterFxn', true)
        }
    }
}
</script>